module.exports = __webpack_public_path__ + "img/H.71a1a25a.svg";